<script>
export let img
export let title
export let text
export let delay = 0
</script>

<style>
.feature{ text-align:center; }
.feature > h2{ font-size: 18px; line-height: 25px; letter-spacing: 1.5px; text-transform: uppercase; color:#E6E7E8; opacity:1; margin-top:10px; margin-bottom:10px; }
.feature > p{ font-size: 22px; line-height: 31px; color: #E6E7E8; mix-blend-mode: normal; opacity: 0.6; }
</style>

<div class="feature" data-aos="zoom-in" data-aos-delay={delay}>
    <img src="./res/features/{img}.svg" alt={title}>    
    <h2>{title}</h2>
    <p>{text}</p>
</div>